module.exports = __webpack_public_path__ + "static/img/notLoginHead@2x.2ab0b53d.png";